import { useEffect, useState } from "react";
import { companyService } from "../../services/api";

export default function Enterprise({ darkMode }) {
  const [formData, setFormData] = useState({
    companyName: "",
    address: "",
    email: "",
    mobile: "",
    pfCode: "",
    esiCode: "",
    labourLicense: "",
    domainName: "",
    contactPerson: "",
    website: "",
    superAdminID: "",
    password: "",
    logo: null,
  });

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const storedCompanyData = localStorage.getItem("companyData");
        if (storedCompanyData) {
          const data = JSON.parse(storedCompanyData);
          setFormData({
            companyName: data.name,
            address: data.address,
            email: data.email,
            mobile: data.phone,
            pfCode: data.pfCode,
            esiCode: data.esiCode,
            labourLicense: data.labourLicense,
            domainName: data.domainName,
            contactPerson: data.contactPerson,
            website: data.website,
            superAdminID: data.superAdminID,
            password: data.password,
            logo: data.logo || null,
          });
          return;
        }

        const user = JSON.parse(localStorage.getItem("currentUser"));
        if (user && user.companyId) {
          const response = await companyService.getCompanyData(user.companyId);
          if (response.success) {
            const data = response.company;
            localStorage.setItem("companyData", JSON.stringify(data));
            setFormData({
              companyName: data.name,
              address: data.address,
              email: data.email,
              mobile: data.phone,
              pfCode: data.pfCode,
              esiCode: data.esiCode,
              labourLicense: data.labourLicense,
              domainName: data.domainName,
              contactPerson: data.contactPerson,
              website: data.website,
              superAdminID: data.superAdminID,
              password: data.password,
              logo: data.logo || null,
            });
          }
        }
      } catch (error) {
        console.error("Error fetching company data:", error);
      }
    };

    fetchCompanyData();
  }, []);

  return (
    <div
      className={`min-h-full p-4 sm:p-6 lg:p-8 ${
        darkMode ? "bg-gray-900 text-gray-100" : "bg-white text-gray-900"
      }`}
    >
      <div
        className={`rounded-xl border p-5 shadow-panel sm:p-6 ${
          darkMode
            ? "border-[#3C3C3C] bg-[#1f1f1f]"
            : "border-gray-200 bg-white"
        }`}
      >
        <h1 className="rh-page-title dark:text-gray-100">Enterprise Details</h1>
        <p className="rh-page-subtitle dark:text-gray-400">
          Read-only company profile fields synced from your organization record.
        </p>

        <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <InputField
            label="Company Name"
            placeholder="Company Name"
            name="companyName"
            value={formData.companyName}
            darkMode={darkMode}
          />
          <InputField
            label="Address"
            placeholder="Address"
            name="address"
            value={formData.address}
            darkMode={darkMode}
          />
          <InputField
            label="Email ID"
            placeholder="Email ID"
            name="email"
            value={formData.email}
            darkMode={darkMode}
          />
          <InputField
            label="Mobile Number"
            placeholder="Mobile Number"
            name="mobile"
            value={formData.mobile}
            darkMode={darkMode}
          />
          <InputField
            label="PF Code No."
            placeholder="PF Code No."
            name="pfCode"
            value={formData.pfCode}
            darkMode={darkMode}
          />
          <InputField
            label="ESI Code No."
            placeholder="ESI Code No."
            name="esiCode"
            value={formData.esiCode}
            darkMode={darkMode}
          />
          <InputField
            label="Labour License No."
            placeholder="Labour License No."
            name="labourLicense"
            value={formData.labourLicense}
            darkMode={darkMode}
          />
          <InputField
            label="Domain Name"
            placeholder="Domain Name"
            name="domainName"
            value={formData.domainName}
            darkMode={darkMode}
          />
          <InputField
            label="Contact Person"
            placeholder="Contact Person"
            name="contactPerson"
            value={formData.contactPerson}
            darkMode={darkMode}
          />
          <InputField
            label="Website"
            placeholder="Website"
            name="website"
            value={formData.website}
            darkMode={darkMode}
          />
          <InputField
            label="Password"
            placeholder="Password"
            name="password"
            value={formData.password}
            darkMode={darkMode}
          />

          {formData.logo && (
            <div className="flex items-center space-x-4 lg:col-span-2">
              <img
                src={formData.logo}
                alt="Company Logo"
                className="h-20 w-20 border border-gray-200 object-contain dark:border-gray-600"
              />
              <span
                className={`text-sm ${darkMode ? "text-gray-400" : "text-gray-600"}`}
              >
                Logo on file
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function InputField({ label, placeholder, name, value, darkMode }) {
  return (
    <div className="space-y-1">
      <label
        htmlFor={`enterprise-${name}`}
        className="rh-micro-label block dark:text-gray-400"
      >
        {label}
      </label>
      <input
        id={`enterprise-${name}`}
        name={name}
        type="text"
        value={value}
        readOnly
        placeholder={placeholder || label}
        className={`w-full rounded-lg border px-3 py-2 text-sm outline-none transition-shadow focus:border-redhalo-red focus:ring-2 focus:ring-redhalo-red/30 ${
          darkMode
            ? "border-gray-600 bg-[#2a2a2a] text-gray-200 placeholder:text-gray-500"
            : "border-gray-300 bg-white text-gray-900 placeholder:text-gray-500"
        }`}
      />
    </div>
  );
}
